import React, {useState, useEffect} from 'react';
import {Navigate} from 'react-router-dom'

import mail from '../../../assets/Icones/mail.png'
import tel from '../../../assets/Icones/tel.png'
import pin from '../../../assets/Icones/pin-localisation-blanche.png'
import logo_long from '../../../assets/DiagoRisk/DiagoRisk-logoallongé_blanc.png'
import LI from '../../../assets/Icones/LinkedIn.png'
import Pdf_CGU from '../../../assets/PDF/2023-07-10_CGU.pdf'
import Pdf_CGV from '../../../assets/PDF/2023-07-10_CGV.pdf'

function FooterSW() {
    const [goToML, setGoToML] = useState(false)
    const [goToPDD, setGoToPDD] = useState(false)
    const [goToHome, setGoToHome] = useState(false)
    const [goToDiag, setgoToDiag] = useState(false)
    const [goToBlog, setGoToBlog] = useState(false)
    const [goToProjets, setgoToProjets] = useState(false)
    const [goToQSN, setGoToQSN] = useState(false)
    const [goToConnexion, setGoToConnexion] = useState(false)
    const [goToSimulation, setGoToSimulation] = useState(false)
    const [goToDR50, setGoToDR50] = useState(false)
    const [idAgent, setidAgent] = useState();
    const [role, setrole] = useState();
    const url = window.location.href
    const root = window.location.origin

    useEffect(() => {
      const items = JSON.parse(localStorage.getItem('idAgent'));
      const items2 = JSON.parse(localStorage.getItem('role'));
      if (items) {
        setidAgent(items);
        setrole(items2)
      }
    }, []);
  
    function handleClickML(event) {
      event.preventDefault()
      setGoToML(true)
    }
  
    function handleClickPDD(event) {
      event.preventDefault()
      setGoToPDD(true)
    }
    function handleClickHome(event) {
      event.preventDefault()
      setGoToHome(true)
    }
    function handleClickDC(event) {
        event.preventDefault()
        setgoToDiag(true)
    }
    function handleClickProjets(event) {
        event.preventDefault()
        setgoToProjets(true)
    }
    function handleClickQSN(event) {
        event.preventDefault()
        setGoToQSN(true)
    }
    function handleClickBlog(event) {
        event.preventDefault()
        setGoToBlog(true)
    }
    function handleSubmitAccesCompte(event) {
      event.preventDefault()
      if(idAgent !== undefined) {
        setGoToSimulation(true)
      }
      else {
        setGoToConnexion(true)
      }
    }
    function handleSubmitDR50(event) {
      event.preventDefault()
      setGoToDR50(true)
    }
    
    if(goToML) {
        return <Navigate push to={`/mentionslegales`} />
    }
    if(goToPDD) {
    return <Navigate push to={`/protectiondesdonnees`} />
    }
    if(goToHome) {
      return <Navigate push to={`/`} />
    }
    if(goToDiag) {
        return <Navigate push to={`/diagnostics_climatiques`} />
    }
    if(goToProjets) {
        return <Navigate push to={`/projets`} />
    }
    if(goToBlog) {
        return <Navigate push to={`/blog`} />
    }
    if(goToQSN) {
        return <Navigate push to={`/quisommesnous`} />
    }
    if(goToConnexion) {
      return <Navigate push to={`/connexion`} />
    }
    if(goToSimulation) {
      return <Navigate push to={`/simulations`}/>
    }
    if(goToDR50) {
      return <Navigate push to={`/diagorisk2050`}/>
    }
  
    return (
      <div>  
        <div className='footer' style={{color:'rgb(146, 208, 80)'}}>
          <div className='footer_gauche'>
            <img src={logo_long}  alt="logo"  style={{width:"75%"}}/>
          </div>

          <div className='footer_centre_gauche'>
            <div style={{display:'flex', flexDirection:'column', justifyContent:'flex-start'}}>
              <div className='titreMoinsMoins' style={{marginBottom:'0px', marginTop:'5%', color:'#92D050'}} > Accès rapide :</div>
              <ul>
                <li> <button onClick={handleClickHome} className='paragraphe buttonSiteFooter' disabled={url===root+'/' ? true : false}> Accueil</button > </li>
                <li> <button onClick={handleClickDC} className='paragraphe buttonSiteFooter' disabled={url.indexOf("diagnostics_climatiques") > -1 ? true : false}> Diagnostics climatiques</button> </li>
                <li> <button onClick={handleClickProjets} className='paragraphe buttonSiteFooter' disabled={url.indexOf("projets") > -1 ? true : false}> Projets </button> </li>
                <li> <button onClick={handleClickQSN} className='paragraphe buttonSiteFooter' disabled={url.indexOf("quisommesnous") > -1 ? true : false}> Qui sommes-nous ? </button> </li>
                <li> <button onClick={handleClickBlog} className='paragraphe buttonSiteFooter' disabled={url.indexOf("blog") > -1 ? true : false}> Actus</button> </li>
              </ul>
            </div>
          </div>

          <div className='footer_centre'> 
            <div>
              <img src={pin} style={{marginTop:'1%'}} alt="Icone de localisation" className="logo_pin_Footer"/>
              <div className='paragraphe'>25 rue Petrelle </div>
              <div className='paragraphe' style={{marginBottom:'5px'}} >75009 Paris </div>
            </div>
          </div>

          <div className='footer_droit' style={{marginBottom:'0px', marginTop:'0%'}}> 
            <div style={{width:'50%'}}>
              <div className='titreMoins' style={{marginBottom:'10px', marginTop:'0px'}} > Contact</div>
              
              <div className='row contactLeft '>
                <img src={mail} alt="icone mail" className="logo_contact"/>
                <a href='mailto:contact@diagorisk.com' className='paragraphe buttonSiteFooter'> contact@diagorisk.com </a>
              </div>
              <div className='row contactLeft'>
                <img src={tel} alt="icone téléphone" className="logo_contact"/>
                <a href='tel:+33(0)6.85.48.01.87' className='paragraphe buttonSiteFooter'> +33(0)6.85.48.01.87 </a>
              </div>
            </div>
            <a href='https://www.linkedin.com/company/diagorisk/'  target='_blank' rel="noopener noreferrer" style={{width:'15%'}}><img src={LI} alt="Logo LinkedIn cliquable" className="logo_LI"/></a>
          </div>
        </div>
  
        <div className='copyright'>
          <div style={{marginLeft:"10px"}} className='paragraphe'>Copyright © 2021 RisquesAgricoles SAS</div>
          <div className='row' style={{marginRight:"10px"}} >
            <button className='ButtonHome buttonFooter' onClick={handleClickML} > Mentions légales </button>
            <div className='buttonFooter'> | </div>
            <button className='ButtonHome buttonFooter' onClick={handleClickPDD} > Protection des données </button>
            <div className='buttonFooter'> | </div>
            <a href = {Pdf_CGU} className='ButtonHome buttonFooter' target='_blank' rel="noopener noreferrer">Conditions générales d'utilisation </a>
            <div className='buttonFooter'>   | </div>
            <a href = {Pdf_CGV} className='ButtonHome buttonFooter' target='_blank' rel="noopener noreferrer">Conditions générales de vente </a>
          </div>
        </div>
      </div>
    );
  }
  
  export default FooterSW;
  
  